import { UserOrder } from "../interfaces";
import { updateOrderApi, updateOrderApiCustomer } from "../api";
import { toast } from "react-toastify";
import { useUser } from "../contexts";

const useOrder = () => {
  const [{ user }] = useUser();
  /**
   * This method is used to update order on backend throw api call
   * @param { Partial<UserOrder> & { id: string } } order order details that need to be updated
   * @param { string } successMessage toast message after order updated successfully
   * @returns flag order for success or null for error depend on api call
   */
  const handleOrderUpdate = async (
    order: Partial<UserOrder> & { id: string },
    successMessage?: string
  ) => {
    try {
      let responseOrder = null;
      if (user?.isAdmin || user?.isManufacturer) {
        responseOrder = await updateOrderApi({
          ...order,
          lastUpdatedBy: (user && user.email ? user.email : order.email) ?? "",
        });
      } else {
        responseOrder = await updateOrderApiCustomer({
          ...order,
          lastUpdatedBy: (user && user.email ? user.email : order.email) ?? "",
        });
      }
      if (!responseOrder) return null;
      if (successMessage) toast.success(successMessage);
      return responseOrder;
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to update order please contact admin.");
      }
      return null;
    }
  };

  return { handleOrderUpdate };
};

export default useOrder;
